import cx from "classnames"
import React, { MouseEvent, PureComponent } from "react"
import * as i18n from "tb-i18n"
import "tb-icons/lib/styles/tb-icons.css"
import { ProductsMatrixDataType } from "../homepage.module"
const styles = require("./product-card.styl")

interface Props
    extends Pick<
        ProductsMatrixDataType,
        "title" | "subtitle" | "icon" | "themeColor" | "isWIP" | "link"
    > {
    active: boolean
    onMouseEnter?: (event: MouseEvent<HTMLAnchorElement>) => void
    onMouseLeave?: (event: MouseEvent<HTMLAnchorElement>) => void
}
export default class ProductCard extends PureComponent<Props> {
    render() {
        const {
            onMouseEnter,
            onMouseLeave,
            title,
            active,
            subtitle,
            icon,
            themeColor,
            isWIP,
            link
        } = this.props
        return (
            <a
                className={ cx(styles["product-card"], { active }, { isWIP }) }
                onMouseEnter={ onMouseEnter }
                onMouseLeave={ onMouseLeave }
                href={ link ? link : "javascript:void(0);" }
                target={ link ? "_blank" : "" }
            >
                <div
                    className="product-card-icon"
                    style={{ backgroundImage: `url(${icon})` }}
                />
                <div className="product-card-text">
                    <div className="product-card-text-title">
                        {title}
                        {this.renderWIP(isWIP)}
                    </div>
                    <div className="product-card-text-subtitle">{subtitle}</div>
                </div>
                <div className="product-card-arrow">
                    <div
                        className="product-card-arrow-back"
                        style={{ background: themeColor }}
                    />
                    {this.renderRightArrow()}
                </div>
            </a>
        )
    }
    renderWIP(isWIP: boolean) {
        if (isWIP) {
            return (
                <span className="product-card-text-title-tip">
                    {i18n.get("homepage.comingSoon")}
                </span>
            )
        }
        return null
    }
    renderRightArrow() {
        const { isWIP, themeColor } = this.props
        return !isWIP ? (
            <span
                className="icon icon-arrow-right"
                style={{ color: themeColor }}
            />
        ) : null
    }
}
